import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { giveProfile } from '../Components/global-notification/notification-list';

const OrgWisePermissions = (moduleType) => {
  let FilteredPermissionObject;
  const { relation } = useParams();
  const profilerelation = giveProfile(relation);
  const orgConfig = useSelector(
    (state) =>
      state?.omniDetails?.fetchOrganizationDetail?.fetchOrganizationDetails
        ?.data?.orgConfiguration
  );

  if (orgConfig) {
    const FilterModule = orgConfig?.find((item) => item.module === moduleType);
    if (FilterModule) {
      const FilterProfile = FilterModule?.configure?.find(
        (item) => item.profileType === profilerelation
      );
      if (FilterProfile) {
        const FilteredPermission = FilterProfile?.setup;
        FilteredPermissionObject = FilteredPermission;
      }
    }
  }

  return FilteredPermissionObject;
};

export default OrgWisePermissions;
